var map = {
	"./links/links.json": 2775,
	"./projects/basketbot.json": 9794,
	"./projects/fluid_simulation.json": 3521,
	"./projects/furifist.json": 7045,
	"./projects/interact_with_iot.json": 2177,
	"./projects/my_origami.json": 9084,
	"./projects/remote_controller.json": 2118,
	"./projectsOrder.json": 7386,
	"./publications/3d_ring.json": 9134,
	"./publications/calibread.json": 555,
	"./publications/cometic.json": 8156,
	"./publications/keepout.json": 8603,
	"./publications/thermotion.json": 725,
	"./publications/understanding_overreliance.json": 404,
	"./publicationsOrder.json": 8581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6846;